import { watch } from 'vue';

import type { MapDisplayOptions, MapFeatureData } from '@/components/map/useMapData';


type DebouncedUpdateSource = {
	(doFit: boolean): void;
	cancel: () => void;
};


type UseMapSourceWatchersParams = {
	featureData: MapFeatureData;
	displayOptions: MapDisplayOptions;
	debouncedUpdateSource: DebouncedUpdateSource;
};


export function useMapSourceWatchers(params: UseMapSourceWatchersParams): void {
	const {
		featureData,
		displayOptions,
		debouncedUpdateSource,
	} = params;

	watch(featureData.baseStations, (to, from) => {
		debouncedUpdateSource(to.length > 0 && from.length === 0);
	});
	watch(
		[
			featureData.rovers,
			featureData.gridpoints,
			displayOptions.showGridpointsOnly,
			displayOptions.fillCoverageArea,
			displayOptions.roversHistoryAutoUpdate,
			displayOptions.qualityColorMode,
		],
		() => {
			debouncedUpdateSource(false);
		},
	);
	watch(featureData.roversHistoryPaths, (to, from) => {
		debouncedUpdateSource(to.length > 0 && from.length === 0);
	});
}
